<template>
  <header class="page-projects-header">
    <!-- Title -->
    <div class="row-1">
      <h1
        data-animate="header-title"
        class="title-xl page-projects-header__title"
        v-if="header?.generalHeaderTitle"
      >
        {{ header.generalHeaderTitle }}
      </h1>
      <div
        v-if="header?.generalHeaderText"
        data-animate="header-content"
        class="page-projects-header__text text-l m-top-6"
        v-html="header.generalHeaderText"
      />
    </div>
  </header>
</template>

<script>
export default {
  name: 'PagesProjectsHeader',
}
</script>

<script setup>
const props = defineProps({
  header: Object,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
